import _ from 'lodash'
export default {
  props: {
    index: {
      type: Number
    },
    section: {
      type: Object
    },
    templateType: {
      type: String
    },
    menu: {
      type: String
    }
  },
  data () {
    return {
      data: undefined
    }
  },
  methods: {
    title (index = 0) {
      return this.data.title[index] ? this.data.title[index].text : ''
    },
    multiTitle () {
      return this.data.title
    },
    subTitle (index = 0) {
      return this.data.subtitle[index] ? this.data.subtitle[index].text : ''
    },
    subTitleColor (index = 0) {
      return this.data.subtitle[index].color ? 'color:' + this.data.subtitle[index].color : ''
    },
    bgColor () {
      return this.data.bgcolor ? this.data.bgcolor : ''
    },
    bgColorStyle () {
      return this.data.bgcolor ? 'background:' + this.data.bgcolor : ';'
    },
    titleIcon (index = 0) {
      return this.data.title[index].icon
    },
    titleColor (index = 0) {
      return this.data.title[index].color ? 'color:' + this.data.title[index].color : ''
    },
    titleBgColor (index = 0) {
      return this.data.title[index].color ? 'background:' + this.data.title[index].color : ''
    },
    titleCount () {
      return +this.data.title_count
    },
    titleImage () {
      return this.data.title_img ? location.protocol + '//' + this.data.title_img : ''
    },
    titleImageStyle () {
      return this.data.title_img ? 'background-image:url(' + this.titleImage() + ')' : ''
    },
    topText1 (index = 0) {
      return this.data.top_list[index].top_text1
    },
    topText2 (index = 0) {
      return this.data.top_list[index].top_text2
    },
    topList () {
      return this.data.top_list
    },
    topListCount () {
      return +this.data.top_list_count
    },
    bottomList (index = 0) {
      return this.data.top_list[index].bottom_list
    },
    bottomListLimit (index, limit) {
      if (this.bottomListCount()) {
        this.data.top_list[index].bottom_list =
          this.data.top_list[index].bottom_list.slice(0, limit)
      }
    },
    bottomListCount (index = 0) {
      return this.data.top_list.length && this.data.top_list[index].bottom_list
        ? this.data.top_list[index].bottom_list.length : 0
    },
    bottomPageCount (index = 0) {
      return +this.data.top_list[index].bottom_page_count
    },
    bottomImage (topIndex = 0, bottomIndex = 0) {
      var image = this.data.top_list[topIndex].bottom_list[bottomIndex].bottom_img
      return image ? location.protocol + '//' + image : ''
    },
    bottomImageStyle (topIndex = 0, bottomIndex = 0) {
      var image = this.bottomImage(topIndex, bottomIndex)
      return image ? 'background-image:url(' + image + '); ' : ''
    },
    bottomTarget (topIndex = 0, bottomIndex = 0) {
      var link = this.data.top_list[topIndex].bottom_list[bottomIndex].bottom_link
      if (link.indexOf('www.wavve.com') >= 0) return '_self'
      else if (link.indexOf('wavve.com') >= 0) return '_blank'
      return '_blank'
    },
    isBottomLink (topIndex = 0, bottomIndex = 0) {
      var link = this.data.top_list[topIndex].bottom_list[bottomIndex].bottom_link
      if (!link) {
        return false
      }
      return true
    },
    bottomLink (topIndex = 0, bottomIndex = 0) {
      const link = this.data.top_list[topIndex].bottom_list[bottomIndex].bottom_link
      // else if (link.indexOf('www.wavve.com') >= 0) return link.replace('www.wavve.com', '')
      // else if (link.indexOf('window.showTagSearchLayout') >= 0) {
      //   /* eslint-disable */
      //   return 'javascript: ' + link + ';';
      // } else if (link) {
      //   return url(link);
      // }
      return link
    },
    bottomLinkPc (topIndex = 0, bottomIndex = 0) {
      return this.data.top_list[topIndex].bottom_list[bottomIndex].bottom_link_param1
    },
    bottomLink2 (topIndex = 0, bottomIndex = 0) {
      return this.data.top_list[topIndex].bottom_list[bottomIndex].bottom_link_param2
    },
    bottomIcons (topIndex = 0, bottomIndex = 0) {
      return this.data.top_list[topIndex].bottom_list[bottomIndex].bottom_osd_icons
    },
    bottomOsdText (topIndex = 0, bottomIndex = 0) {
      return this.data.top_list[topIndex].bottom_list[bottomIndex].bottom_osd_text
    },
    bottomRatio (topIndex = 0, bottomIndex = 0) {
      return this.data.top_list[topIndex].bottom_list[bottomIndex].bottom_ratio
    },
    bottomText1 (topIndex = 0, bottomIndex = 0) {
      return _.get(this.bannerInfo, ['top_list', '0', 'bottom_list', '0', 'bottom_text1'], '')
    },
    bottomText2 (topIndex = 0, bottomIndex = 0) {
      let text2 = _.get(this.bannerInfo, ['band', 'celllist', '0', 'title_list', '0', 'text'], '')
      return text2
    },
    bottomText3 (topIndex = 0, bottomIndex = 0) {
      return this.data.top_list[topIndex].bottom_list[bottomIndex].bottom_text3
    },
    bottomText4 (topIndex = 0, bottomIndex = 0) {
      return this.data.top_list[topIndex].bottom_list[bottomIndex].bottom_text4
    },
    bottomType (topIndex = 0, bottomIndex = 0) {
      return this.data.top_list[topIndex].bottom_list[bottomIndex].content_type
    },
    bottomTargetAge (topIndex = 0, bottomIndex = 0) {
      return +this.data.top_list[topIndex].bottom_list[bottomIndex].targetage
    }
  }
}
